import React from 'react';
import { Zap, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function KidsFitness() {
  return <section className="py-24 bg-ink text-off-white" data-id="element-1915">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1916">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1917">
          <div data-id="element-1918">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1919">
              <Zap className="w-3.5 h-3.5" data-id="element-1920" />
              Active Bodies
            </div>
            <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-1921">
              Fitness, Coordination & Strength
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1922">
              Kids today sit a lot. Storm classes flip that — every session is
              an hour of running, jumping, kicking, stretching, and challenging
              the body in ways that build lifelong physical literacy.
            </p>
            <ul className="space-y-3" data-id="element-1923">
              {['Cardio endurance from drills, footwork and sparring', 'Leg strength and core stability from kicks and stance work', 'Coordination, agility, and balance — improving every week', 'Flexibility built progressively, not forced', "A healthy outlet for energy that doesn't involve a screen"].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1924">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-1925" />
                  <span className="text-off-white" data-id="element-1926">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-1927">
            <img src={SITE_IMAGES.kidsClasses} alt="Kids doing Taekwondo drills at Storm" className="block rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]" data-id="element-1928" />
          </div>
        </div>
      </div>
    </section>;
}